<template>
    <q-page class="q-pa-md">
        <div class="row q-pt-md q-col-gutter-md">
            <!-- Columna izquierda: solo aparece si mostrarFormulario es true -->

            <div v-if="mostrarFormulario" class="col-md-4 col-12">
                <q-card class="q-pa-md">
                    <q-form @submit="guardarFormulario">
                        <div class="text-h6 q-mb-md">Nueva Marca</div>
                        <q-input v-model="formulario.marca" outlined label="Nombre de marca" class="q-mb-md" dense
                            required />
                        <!-- <q-input v-model="formulario.imagen" outlined label="URL Imagen" class="q-mb-md" dense
                            required /> -->
                        <div class="col-12 col-md-12">
                            <q-file v-model="archivoSeleccionado" dense outlined label="Imagen de la Marca"
                                class="full-width">
                                <template v-slot:after>
                                    <q-btn round color="primary" icon="mdi-plus" @click="agregarImagen()" />
                                </template>
                            </q-file>
                        </div>

                        <q-img v-if="formulario.imagen.imagBase64 != ''" :src="formulario.imagen.imagBase64"
                            class="q-mt-md cuadrado-img" style=" width: 100%;  "
                            :img-style="{ objectFit: 'contain', backgroundColor: 'white' }" />

                        <div class="row justify-between">
                            <q-btn outline icon="mdi-content-save" v-if="formulario._id != ''" label="Editar"
                                color="primary" type="submit" class=" q-mt-md q-mr-sm" />
                            <q-btn outline icon="mdi-content-save" v-else label="Guardar" color="primary" type="submit"
                                class="q-mt-md q-mr-sm" />
                            <q-btn outline icon="mdi-delete" label="Eliminar" color="primary" type="submit"
                                class="q-mt-md q-mr-sm" />
                            <q-btn outline icon="mdi-close" label="Cerrar" color="negative" class="q-mt-md"
                                @click="mostrarFormulario = false" />
                        </div>
                    </q-form>
                </q-card>
            </div>

            <!-- Columna derecha: tabla ocupa más espacio si no hay formulario -->
            <div :class="mostrarFormulario ? 'col-md-8 col-12' : 'col-12'">
                <q-table dense title="Marcas" class="shadow-1" :data="items" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetMarcas()" no-caps
                            class="q-mr-sm q-my-md" />
                        <q-btn outline color="primary" icon="mdi-plus" class="q-my-md" label="Nuevo"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="marca" :props="props" @click="verItem(props.row)">{{ props.row.marca }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: false,
            mostrarFormulario: false,

            columns: [
                { name: 'marca', label: 'Marca', field: 'marca', align: 'center', sortable: true }
            ],
            formulario: {
                _id: '',
                marca: '',
                imagen: {
                    ruta: '',
                    nombre: '',
                    imagBase64: '',
                },
            },
            initialPagination: {
                sortBy: 'marca',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            archivoSeleccionado: null,

        };
    },
    computed: {
        items() {
            return this.$store.state.auth.listMarcasStore;
        }
    },
    created() {
        this.GetMarcas();
    },
    methods: {
        cerrarItem() {
            this.formulario = {
                _id: '',
                marca: '',
                imagen: {
                    ruta: '',
                    nombre: '',
                    imagBase64: '',
                },
            }
            this.mostrarFormulario = false
        },
        nuevoItem() {
            this.mostrarFormulario = true
            this.formulario = {
                _id: '',
                marca: '',
                imagen: {
                    ruta: '',
                    nombre: '',
                    imagBase64: '',
                },
            }
        },
        verItem(item) {
            this.mostrarFormulario = true
            this.formulario = item
        },
        async GetMarcas() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaMarcas/')
                console.log(respuesa)
                this.$store.state.auth.listMarcasStore = respuesa.data
                this.loading = false

            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async guardarFormulario() {
            try {
                let respuesa = await axios.post('Autos/AltaMarca/', this.formulario)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                if (respuesa.data.edopet == "0") {
                    this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                    this.formulario._id = respuesa.data._id
                    this.$store.state.auth.listMarcasStore.push(this.formulario)
                    this.cerrarItem()
                } else {
                    this.$q.notify({ position: 'top-right', type: 'warning', message: `Error al guardar el item, intntelo de nuevo.` })
                }
            } catch (error) {
                console.log(error)
            }
        },
        async agregarImagen() {
            const archivo = this.archivoSeleccionado;
            this.formulario.imagen.imagBase64 = await this.convertirABase64(archivo);
            this.formulario.imagen.nombre = archivo.name;
        },

        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
};
</script>
<style>
.cuadrado-img img {
    object-fit: contain;
    background-color: white;
}

.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}
</style>